export default __webpack_public_path__ + "static/media/pandaNew.a8dac49e.svg";